import { get, post, postBlob } from '@/utils/apiBase.js';
// 创建小红书种草抽奖
const createPotato = option => {
    return post('/apis/project/cp_admin/create_rednote_draw', option)
}
// 根据小红书抽奖ID获取信息
const getPotato = option => {
    return get('/apis/project/cp_admin/rednote_draw_info', option)
}
// 修改小红书种草抽奖
const editPotato = option => {
    return post('/apis/project/cp_admin/edit_rednote_draw', option)
}
// 小红书种草活动管理页
const getPotatoManage = option => {
    return get('/apis/project/cp_admin/rednote_draw_manage', option)
}
// 获取小红书种草提交凭证用户列表
const getProofList = option => {
    return get('/apis/project/cp_admin/rednote_proof_list', option)
}
// 上传小红书中奖名单
const createRednoteWinner = option => {
    return post('/apis/project/cp_admin/create_rednote_winner', option)
}
// 导出用户上传凭证
const exportRednoteProof = option => {
    return postBlob('/apis/project/cp_admin/export_rednote_proof', option)
}
// 获取小红书中奖用户列表
const getWinnerList = option => {
    return get('/apis/project/cp_admin/rednote_winner_list', option)
}
// 上传发货信息
const postRednoteDelivery = option => {
    return post('/apis/project/cp_admin/rednote_delivery', option)
}
export default {
    createPotato,
    getPotato,
    editPotato,
    getPotatoManage,
    getProofList,
    createRednoteWinner,
    exportRednoteProof,
    getWinnerList,
    postRednoteDelivery
};